import React from 'react';
import {
  Box,
  Container,
  Text,
  VStack,
  HStack,
  Grid,
  GridItem,
  Button,
  Link,
  Image,
} from '@chakra-ui/react';
import logoRF from '../utils/images/logo.png';
import ContactButton from '../utils/ContactButton';
import AttestationRCPro from '../utils/pdf/Attestation_RC_professionnelle MMA 2025.pdf';
import AttestationRCDecennale from '../utils/pdf/Attestation_RC_decennale MMA_01_2025.pdf';

const Footer = () => {
  const contact = {
    email: process.env.REACT_APP_EMAIL || 'contact@groupe-solarenov.com',
    workingHours: process.env.REACT_APP_WORKING_HOURS || 'Lun–Ven 9:00–20:00',
  };

  return (
    <Box as="footer" bg="linear-gradient(135deg, #2c3e50 0%, #34495e 100%)" color="white" py={{ base: 12, lg: 16 }}>
      <Container maxW="1200px" px={5}>
        {/* Footer Content */}
        <Grid
          templateColumns={{ base: '1fr', md: 'repeat(2, 1fr)' }}
          gap={{ base: 8, lg: 10 }}
          mb={10}
        >
          {/* Company Info */}
          <GridItem>
            <VStack align="center" spacing={6} textAlign="center">
              <Image src={logoRF} alt="Groupe Solarenov" h={{ base: '48px', md: '56px' }} objectFit="contain" />
              <VStack align="center" spacing={4} w="100%">
                <ContactButton />
                <HStack spacing={3} justify="center">
                  <Text color="white" fontWeight={600}>Email :</Text>
                  <Link href={`mailto:${contact.email}`} color="white" _hover={{ color: 'white', opacity: 0.85 }}>
                    {contact.email}
                  </Link>
                </HStack>
                <HStack spacing={3} justify="center">
                  <Text color="white" fontWeight={600}>Horaires :</Text>
                  <Text color="white">
                    {contact.workingHours}
                  </Text>
                </HStack>
                <HStack spacing={{ base: 2, md: 3 }} flexWrap="wrap" justify="center" pt={2}>
                  <Button
                    as="a"
                    href={AttestationRCPro}
                    download
                    size="xs"
                    borderRadius="full"
                    bg="white"
                    color="gray.900"
                    fontWeight={700}
                    _hover={{ bg: 'gray.100', transform: 'translateY(-1px)' }}
                    transition="all 0.2s ease"
                  >
                    Attestation RC pro
                  </Button>
                  <Button
                    as="a"
                    href={AttestationRCDecennale}
                    download
                    size="xs"
                    borderRadius="full"
                    bg="#094c26"
                    color="white"
                    fontWeight={700}
                    _hover={{ bg: '#0d6b35', transform: 'translateY(-1px)' }}
                    transition="all 0.2s ease"
                  >
                    Attestation RC décennale
                  </Button>
                </HStack>
              </VStack>
            </VStack>
          </GridItem>

          {/* Pages */}
          <GridItem>
            <VStack align="center" spacing={5} textAlign="center">
              <Text fontSize="lg" fontWeight={700} color="white">
                Pages
              </Text>
              <VStack align="center" spacing={3}>
                <Link href="/" color="white" fontSize="sm" _hover={{ color: 'white', opacity: 0.85, transform: 'translateY(-2px)' }} transition="all 0.3s ease">
                  Accueil
                </Link>
                <Link href="/contact" color="white" fontSize="sm" _hover={{ color: 'white', opacity: 0.85, transform: 'translateY(-2px)' }} transition="all 0.3s ease">
                  Contact
                </Link>
                <Link href="/mentions-legales" color="white" fontSize="sm" _hover={{ color: 'white', opacity: 0.85, transform: 'translateY(-2px)' }} transition="all 0.3s ease">
                  Mentions légales
                </Link>
                <Link href="/confidentialite" color="white" fontSize="sm" _hover={{ color: 'white', opacity: 0.85, transform: 'translateY(-2px)' }} transition="all 0.3s ease">
                  Confidentialité
                </Link>
                <Link href="/cookies" color="white" fontSize="sm" _hover={{ color: 'white', opacity: 0.85, transform: 'translateY(-2px)' }} transition="all 0.3s ease">
                  Cookies
                </Link>
              </VStack>
            </VStack>
          </GridItem>
        </Grid>

        {/* Company description */}
        <Box maxW="900px" mx="auto" textAlign="center" mb={8}>
          <Text color="white" fontSize={{ base: 'sm', md: 'md' }} opacity={0.95}>
            Groupe Solarenov
          </Text>
          <Text mt={2} color="white" fontSize={{ base: 'sm', md: 'md' }} opacity={0.9}>
            Solutions énergétiques durables sur l'ensemble du territoire français.
          </Text>
        </Box>

        {/* Footer Bottom */}
        <Box
          borderTop="1px solid"
          borderColor="rgba(255, 255, 255, 0.1)"
          pt={5}
        >
          <VStack spacing={3} align="center" textAlign="center" w="100%">
            <Text color="white" fontSize="sm">
              © {new Date().getFullYear()} Groupe Solarenov. Tous droits réservés.
            </Text>
            <HStack spacing={5} justify="center">
              <Link href="/mentions-legales" color="white" fontSize="sm" _hover={{ color: 'white', opacity: 0.85 }}>
                Mentions légales
              </Link>
              <Link href="/confidentialite" color="white" fontSize="sm" _hover={{ color: 'white', opacity: 0.85 }}>
                Confidentialité
              </Link>
              <Link href="/cookies" color="white" fontSize="sm" _hover={{ color: 'white', opacity: 0.85 }}>
                Cookies
              </Link>
            </HStack>
          </VStack>
        </Box>
      </Container>
    </Box>
  );
};

export default Footer;
